import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import api, { TOKEN_STORAGE_KEY } from '../api/client';
import { createStatusIntent } from '../api/statusIntent';

export default function useDesktopStatusIntent(user) {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  const owner = user?.id && token ? JSON.stringify([user.id, user.rangerId, token]) : null;
  const latestOwner = useRef(owner); latestOwner.current = owner;
  const refreshRef = useRef(null);
  const [state, setState] = useState({ owner: null, revision: 0, pending: false, error: '' });
  const channel = useMemo(() => createStatusIntent({ api,
    currentSession: () => owner && latestOwner.current === owner && localStorage.getItem(TOKEN_STORAGE_KEY) === token ? token : null,
    notify: next => setState({ owner, ...next }),
    refreshCanonical: () => refreshRef.current(),
  }), [owner, token]);
  useEffect(() => { channel.activate(); return () => channel.dispose(); }, [channel]);
  const mark = useCallback(() => channel.mark(), [channel]);
  const flush = useCallback((payload, refresh) => { refreshRef.current = refresh; channel.flush(payload); }, [channel]);
  const retry = useCallback(() => channel.retry(), [channel]);
  const discard = useCallback(() => channel.discard(), [channel]);
  const visible = state.owner === owner ? state : { revision: 0, pending: false, error: '' };
  return { ...visible, mark, flush, retry, discard };
}
